// @ts-nocheck
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { imageConfig } from '../../../../config/config'
import { getText } from '../../../../utils/util'
import { ArrowDown } from 'lucide-react'
import './index.css'

export default function TopText({ setIsShowCoin, nowTab, coinListData, ctmarketlist }) {
  const navigate = useNavigate()
  const [num, setNum] = useState(1)
  const { t: translate } = useTranslation()

  const getName = (name) => {
    let name2 = ''
    for (const ctmarket of ctmarketlist) {
      if (name == ctmarket.coinname) {
        name2 = ctmarket.type === 2 ? ctmarket?.issueName : ctmarket.coinname.toUpperCase()
        break
      }
    }
    return name2 || name?.toUpperCase()
  }

  const priceChange = coinListData[nowTab]?.close - coinListData[nowTab]?.open
  const percentChange = coinListData[nowTab]?.close 
    ? ((priceChange / coinListData[nowTab]?.open) * 100).toFixed(2)
    : "0.00"
  
  const isPositive = priceChange > 0

  return (
    <div className="p-4">
      <div className="flex justify-between items-center">
        <div 
          className="flex items-center gap-1 cursor-pointer text-white font-medium"
          onClick={() => {
            setIsShowCoin(true)
          }}
        >
          <span className="text-lg">{getName(nowTab)}/USDT</span>
          <ArrowDown size={16} className="ml-1" />
        </div>
        <div className="flex items-center gap-2">
          <span className={`${isPositive ? 'text-green-500' : 'text-red-500'} font-medium`}>
            {priceChange?.toFixed(2)}
          </span>
          <span className={`rounded px-2 py-1 text-sm font-medium ${isPositive ? 'bg-green-500/20 text-green-500' : 'bg-red-500/20 text-red-500'}`}>
            {isPositive ? '+' : ''}{percentChange}%
          </span>
        </div>
      </div>
      <div className="text-2xl font-bold mt-2 text-white">
        {coinListData[nowTab]?.close || '0.00'}
      </div>
      
      <div className="grid grid-cols-4 gap-4 mt-4">
        <div className="text-center">
          <p className="text-xs text-neutral-400 mb-1">{translate(getText('開盤'))}</p>
          <div className="text-sm text-white">{coinListData[nowTab]?.open}</div>
        </div>
        <div className="text-center">
          <p className="text-xs text-neutral-400 mb-1">{translate(getText('成交量'))}</p>
          <div className="text-sm text-white">
            {(coinListData[nowTab]?.vol / 10000).toFixed(2)}
            {translate(getText('萬'))}
          </div>
        </div>
        <div className="text-center">
          <p className="text-xs text-neutral-400 mb-1">{translate(getText('最低'))}</p>
          <div className="text-sm text-white">{coinListData[nowTab]?.low}</div>
        </div>
        <div className="text-center">
          <p className="text-xs text-neutral-400 mb-1">{translate(getText('最高'))}</p>
          <div className="text-sm text-white">{coinListData[nowTab]?.high}</div>
        </div>
      </div>
    </div>
  )
}
